import OpenDialogAction from './OpenDialogAction';

export default OpenDialogAction.extend({
    isApplicable: function (selectedItems) {
        return selectedItems.every(selectedItem => selectedItem.deprecated !== "true");
    }
});